export const arrowDownSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 11L12 15L8 11" class="stroke" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
